
import { createContext } from "react";

import { IFormField, SpeciesForm } from '../../api/dtos/dtos';
import useGetSpeciesForms from "../../hooks/data/useGetSpeciesForms";

export interface ISpeciesFormContext extends Omit<ReturnType<typeof useGetSpeciesForms>, 'data' | 'total' | 'offset'> {
    data?: SpeciesForm[];
    selectedForm?: SpeciesForm;
    selectedFormFields?: Record<string, IFormField>;
    canClickMap: boolean;
    selectingLocation: boolean;
}

export const SpeciesFormsContext = createContext<ISpeciesFormContext>({
    selectedForm: undefined,
    selectedFormFields: undefined,
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
    canClickMap: false,
    selectingLocation: false
});

export default SpeciesFormsContext;